var React = require('react');
var moment = require('moment');

var TimeFormatter = React.createClass({

	getInitialState: function() {
		return {
			elapsed: 0
		};
	},

	componentWillMount: function() {
		this.timer = setInterval(this.tick, 60000);
	},

	componentWillUnmount: function() {
		clearInterval(this.timer);
	},

	tick: function() {
		this.setState({elapsed: new Date().getTime() - this.state.initial});
	},

	now() {
		return new Date().getTime();
	},

	elapsed(initial) {
		return moment(this.now()).diff(initial);
	},

	render: function() {

		var me = this, elapsedTime = me.elapsed(me.props.data);

		return (
			<div>
				{moment.duration(elapsedTime).format('hh:mm', {trim: false})}
			</div>
		)
	}

});

module.exports = TimeFormatter;


// WEBPACK FOOTER //
// ./src/components/Formatters/TimeFormatter.jsx